export default "__VITE_ASSET__wUyQ4jHx__"